import React, { useState, useEffect } from "react";
import HackLayout from "../components/hacks/HackLayout";
import CreateTransactionComponent from "../components/hacks/CreateTransactionComponent";
import { UserAuth } from "../context/authContext";
import { db } from "../firebaseConfig";
import { FiUser, FiLayers } from "react-icons/fi";
import KeyDisplay from "../components/hacks/KeyDisplay";
import ParticipantList from "../components/hacks/ParticipantList";

const HackCreateTransactionPage = () => {
  const { user } = UserAuth();
  const [userData, setUserData] = useState(null);
  const [roomId] = useState(localStorage.getItem("roomId") || "");
  const [team] = useState(localStorage.getItem("team") || "");

  useEffect(() => {
    if (user?.email) {
      const unsubscribe = db
        .collection("users")
        .doc(user.email)
        .onSnapshot((doc) => {
          if (doc.exists) {
            setUserData(doc.data());
          }
        });
      return () => unsubscribe();
    }
  }, [user]);

  return (
    <HackLayout activeId="create-transaction">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Wallet Details */}
        <div className="glass-card p-6 bg-gradient-to-br from-primary/5 via-transparent to-transparent">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary shrink-0">
              <FiUser size={20} />
            </div>
            <div className="min-w-0">
              <h2 className="text-lg font-bold text-white uppercase tracking-wider">
                Wallet Details
              </h2>
              <p className="text-text-muted text-[10px] opacity-60">
                Manage your keys and network identity
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <KeyDisplay
              label="Your Public Key"
              value={userData?.publicKey}
              color="text-emerald-400"
            />
            <KeyDisplay
              label="Your Private Key"
              value={userData?.privateKey}
              color="text-amber-400"
              isPrivate={true}
            />
          </div>
        </div>

        {/* Participants Section */}
        <div className="glass-card flex flex-col border-primary/20 bg-primary/5 overflow-hidden">
          <div className="px-6 py-3 border-b border-white/5 flex items-center gap-3 bg-white/5">
            <div className="w-8 h-8 rounded-lg bg-primary/20 flex items-center justify-center text-primary shrink-0">
              <FiLayers size={16} />
            </div>
            <div className="min-w-0">
              <h2 className="text-base font-bold text-white truncate uppercase tracking-wider">
                Room Participants
              </h2>
              <p className="text-text-muted text-xs truncate opacity-60">
                Active members in room: {roomId}
              </p>
            </div>
          </div>

          <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <ParticipantList
              title="Red Team Participants"
              roomId={roomId}
              team="red"
              userTeam={team}
              type="participants"
              currentUserPk={userData?.publicKey}
            />
            <ParticipantList
              title="Blue Team Participants"
              roomId={roomId}
              team="blue"
              userTeam={team}
              type="participants"
              currentUserPk={userData?.publicKey}
            />
            <ParticipantList
              title="Red Team Miners"
              roomId={roomId}
              team="red"
              userTeam={team}
              type="miners"
              currentUserPk={userData?.publicKey}
            />
            <ParticipantList
              title="Blue Team Miners"
              roomId={roomId}
              team="blue"
              userTeam={team}
              type="miners"
              currentUserPk={userData?.publicKey}
            />
          </div>
        </div>

        {/* Transaction Creation */}
        <div className="glass-card p-6 border border-white/10 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-48 h-48 bg-primary/5 blur-[80px] pointer-events-none -mr-24 -mt-24"></div>
          <CreateTransactionComponent user={user} userData={userData} roomId={roomId} team={team} />
        </div>
      </div>
    </HackLayout>
  );
};

export default HackCreateTransactionPage;
